import { render, staticRenderFns } from "./check-apply.vue?vue&type=template&id=04707546&scoped=true&"
import script from "./check-apply.vue?vue&type=script&lang=js&"
export * from "./check-apply.vue?vue&type=script&lang=js&"
import style0 from "./check-apply.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./check-apply.vue?vue&type=style&index=1&id=04707546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04707546",
  null
  
)

export default component.exports